<template>
	<div id="presets" class="flex column gap-s">
		<div class="title">
			<div class="huge-font">KILIM</div>
			<div class="large-font">{{ getLocale('choose_pattern') }}</div>
		</div>
		
		<div class="presets  ">
			<div v-for="preset in patterns" class="preset">
				<svg 
					:class="{current : preset.ID == hovered}" 
					@mouseenter="hovered = preset.ID" 
					@mouseleave="hovered = null"
					@click="startConfiguration(preset)"
					:viewBox="'0 0 '+base_tile[0]*scale+' '+base_tile[1]*scale"
				>
					<g :id="'patternpreset'+preset.ID" class="pattern" >
						<template v-for="group in preset.groups" >
							<g v-for="tile in group.tiles" :class="'rotation-'+group.rotation">
								<path 
									v-for="(shape,i) in group.tile.data"
									:d="getTilePath(shape, tile, scale)" 
									:fill="preset.ID == hovered ? group.colors[i] : 'white'"
									stroke="black"
								/>
							</g>
						</template>
					</g>
					
					<template  v-for="x in 3">
						<use 
							v-for="y in 3" 
							:xlink:href="'#patternpreset'+preset.ID" 
							:x="((parseFloat(preset.width)+gap)*scale)*(x-2)" 
							:y="((parseFloat(preset.height)+gap)*scale)*(y-2)"
						/>
					</template >
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	import { commonMixin } from '@/mixins/common.js';
	
	import { mapState, mapMutations } from 'vuex'
	import Button from '@/components/Button.vue'
	
	export default {
		name: 'Presets',
		components: { Button },
		mixins: [ commonMixin ],
		data: function () { return {
			load_modal : false,
			scale: 4,
			hovered : null
		}},
		computed: {
			...mapState([ 'colors', 'patterns', 'tiles', 'presets', 'current_preset', 'base_tile', 'gap' ]),
		},
		methods: {
			...mapMutations([ 'setPreset' ]),
			startConfiguration(preset){
				this.setPreset(preset)
				this.$emit('startConfiguration');
			},
		}
	}
</script>

<style lang="scss">
	#presets{
		position: absolute;
		top: -10px;
		left: -100%;
		width: 100%;
		height: calc(100% + 30px);
		padding: 40px 20px;
		padding-top: 70px;
		background: white;
		z-index: 10;
		overflow-y: auto;
		transition: left 0.3s;
		background: #E4E2DE;
		
		@media (max-width: 599px) {
			padding: 40px 20px;
		}
		
		&.active{
			left: 0;
		}
		
		.presets{
			display: grid;
			grid-template-columns: repeat(5, 180px); 
			grid-template-rows: repeat(2, 1fr); 
			gap: 40px; 
			justify-content: center;
			margin-top: 60px;
			
			.preset{
				position: relative;
				width: 180px;
				height: 180px;
				flex-shrink: 0;
				cursor: pointer;
				background: white;
				filter: grayscale(1);
				
				&.current{
					cursor: default;
				}
				
				> .pattern{
					display: none;
				}
				
				&:after{
					content: '';
					position: absolute;
					inset: 0;
					border: 2px solid black;
					pointer-events: none;
				}
				
				svg{
					position: absolute;
					inset: 0;
					fill-opacity: 0.5;
					
					g.pattern{
						//visibility: hidden;
					}
				}
			}
			
			
			@media (max-width: 1119px) {
				grid-template-columns: repeat(5, 160px); 
				gap: 20px;
				
				.preset{
					width: 160px;
					height: 160px;
				}
			}
			
			
			@media (max-width: 899px) {
				grid-template-columns: repeat(5, 140px); 
				
				.preset{
					width: 140px;
					height: 140px;
				}
			}
			
			@media (max-width: 799px) {
				grid-template-columns: repeat(2, 180px); 
				gap: 40px; 
				
				.preset{
					width: 180px;
					height: 180px;
				}
			}
			
			@media (max-width: 479px) {
				grid-template-columns: repeat(2, 160px); 
				gap: 20px; 
				
				.preset{
					width: 160px;
					height: 160px;
				}
			}
			
			@media (max-width: 379px) {
				grid-template-columns: repeat(2, 140px); 
				
				.preset{
					width: 140px;
					height: 140px;
				}
			}
		}
	}

	
</style>
